import { render, staticRenderFns } from "./BuyerYearInvoice.vue?vue&type=template&id=19deb6a1&scoped=true&"
import script from "./BuyerYearInvoice.vue?vue&type=script&lang=js&"
export * from "./BuyerYearInvoice.vue?vue&type=script&lang=js&"
import style0 from "./BuyerYearInvoice.vue?vue&type=style&index=0&id=19deb6a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19deb6a1",
  null
  
)

export default component.exports